import { SyntheticEvent } from 'react';

export const PLACEHOLDER_IMAGE =
    'data:image/svg+xml;utf8,' +
    encodeURIComponent(
        `<svg xmlns="http://www.w3.org/2000/svg" width="400" height="300" viewBox="0 0 400 300">
            <rect width="400" height="300" fill="#e0e0e0"/>
            <g fill="#9e9e9e">
                <circle cx="150" cy="115" r="28"/>
                <path d="M55 235 L165 145 L215 195 L285 130 L345 235 Z"/>
            </g>
        </svg>`
    );

export function handleImageError(event: SyntheticEvent<HTMLImageElement>) {
    event.currentTarget.onerror = null;
    event.currentTarget.src = PLACEHOLDER_IMAGE;
}
